/** @format */

import styled from "styled-components";

import { Link } from "react-router-dom";

export const Container = styled.div`
  font-family: "Montserrat",sans-serif;
  background-color: ${(props) => props.theme.colors.primary};
  padding: clamp(0.25rem, 2vw, 1.5rem) clamp(0.25rem, 3vw, 3rem);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 5.5rem;
  position: sticky;
  top: 0;
  z-index: 1050;
  .logo {
    font-size: clmap(1rem, 1.5rem, 1.5rem);
    color: ${(props) => props.theme.colors.text};
    text-decoration: none;

    img {
      width: 5rem;
      height: 5rem;
      object-fit: contain;
    }
  }
`;
export const NavLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: clamp(1rem, 2.5vw, 2.5rem);
  @media screen and (max-width: 768px) {
    display: none;
  }
  .dropdown {
    a {
      text-decoration: none;
      color: white;
      display:flex;
      justify-content:center;
      align-items:center;
    }
    ul {
      li {
        padding-left: 10px;
        a {
          width: 100%;
          text-align: center;
          color: ${(props) => props.theme.colors.primary};
          font-size: 17px;
        }
      }
    }
  }
`;
export const NavLink = styled(Link)`
  font-family: "Montserrat",sans-serif;
  text-decoration: none;
  color: ${(props) => props.theme.colors.text};
  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

type CustomProps = {
  isOpen: boolean;
};

export const MobileLinks = styled.div<CustomProps>`
  position: absolute;
  top: 5.5rem;
  height: auto;
  width: 100%;
  padding: 1rem 2rem;
  background: black;
  z-index: 100;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  flex-direction: column;
  left: ${(props) => (props.isOpen ? 100 : 0)}%;
  transition: all 0.3s ease-in-out;
  display: none;

  .dropdown {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .dropdown-toggle {
    font-size: 1.1rem;
    text-decoration: none;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0;
  }

  .dropdown-menu {
    position: static !important;
    transform: none !important;
    background: #1a1a1a;
    border: none;
    border-radius: 6px;
    width: 100%;
    padding: 0.25rem 0;
    margin-top: 0.25rem;

    li {
      padding: 0;

      a {
        text-decoration: none;
        color: #ffffff !important;
        font-size: 1rem;
        padding: 0.4rem 1rem;
        display: block;
        text-align: center;

        &:hover {
          background: #2a2a2a;
        }
      }
    }
  }

  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? "none" : "flex")};
  }
`;

export const MobileSection = styled.div<CustomProps>`
  display: none;
  .svg_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: clamp(0.25rem, 1vw, 0.5rem);

    svg {
      width: clamp(1.25rem, 5vw, 2rem);
      height: clamp(1.25rem, 5vw, 2rem);
    }
  }

  @media screen and (max-width: 768px) {
    display: block;
  }
`;
